@if (market) {
  <div class="header bg-secondary">
    <mat-icon (click)="getMarketSnapshot(marketId?.value, selectionId?.value)">refresh</mat-icon>
    <span>{{ market?.event?.name }} - {{ market?.marketName }}</span>
  </div>
}
<div class="container">
  <div class="graph-container">
    <form [formGroup]="form">
      <mat-form-field appearance="outline" color="primary">
        <mat-select formControlName="selectionId">
          @for (runner of market?.runners; track runner) {
            <mat-option [value]="runner.selectionId">{{ runner.runnerName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
    <table>
      <thead>
        <tr>
          <th>Matched</th>
          <th>
            <div class="extreme-values">
              <b>Low: {{ pricePoints?.low ?? "-" }}</b>
              <b>High: {{ pricePoints?.high ?? "-" }}</b>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <b>On this market:</b>
          </td>
          <td>
            <b>{{ marketSnapshot?.tv | number }}</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>On this selection:</b>
          </td>
          <td>
            <b>{{ currentRunner?.totalMatched | number }}</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>Last price matched:</b>
          </td>
          <td>
            <b>{{ currentRunner?.lastPriceTraded | number }}</b>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="graph" id="chart">
      <h2>Price/Volume over time</h2>
      <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [dataLabels]="chartOptions.dataLabels"
        [plotOptions]="chartOptions.plotOptions"
        [yaxis]="chartOptions.yaxis"
        [xaxis]="chartOptions.xaxis"
        [legend]="chartOptions.legend"
        [colors]="chartOptions.colors"
        [grid]="chartOptions.grid"></apx-chart>
    </div>
  </div>
  <div class="table-container">
    <table>
      <thead class="title-th">
        <tr>
          <th>Price</th>
          <th>To Back</th>
          <th>To Lay</th>
          <th>Traded</th>
        </tr>
      </thead>
      <tbody>
        @for (row of tableRows.back; track row) {
          <tr>
            <td [ngClass]="{ 'bg-back': row.toBack }">{{ row.price }}</td>
            <td [ngClass]="{ 'bg-back': row.toBack }" class="align-end">{{ row.toBack | number: "1.0-0" }}</td>
            <td></td>
            <td class="align-end">{{ row.traded | number: "1.0-0" }}</td>
          </tr>
        }
        @for (row of tableRows.lay; track row) {
          <tr>
            <td [ngClass]="{ 'bg-lay': row.toLay }">{{ row.price }}</td>
            <td></td>
            <td [ngClass]="{ 'bg-lay': row.toLay }" class="align-end">{{ row.toLay | number: "1.0-0" }}</td>
            <td class="align-end">{{ row.traded | number: "1.0-0" }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
